/* eslint-disable css-modules/no-unused-class  */
import { useState, FC, useEffect } from 'react';
import classnames from 'classnames';
import { Button, FullPageLoader, Icon, Search, Tabs } from 'learning-panel-components';
import { translate } from 'translations';
import UserLeaderboardContainer from '@components/play/leaderboard/userLeaderboard/userLeaderboardContainer';
import TeamLeaderboardContainer from '@components/play/leaderboard/teamLeaderboard/teamLeaderboardContainer';
import styles from '../teamLeaderboard/leaderboard.module.scss';

const Leaderboard: FC<LeaderboardProps> = (props: LeaderboardProps) => {
    const { onClose, isOpenTournamentLeaderboard, tournamentUuid, onlyUsers } = props;
    const [tab, setTab] = useState<number>(TabsType.users);
    const [searchString, setSearchString] = useState<string>('');
    const [showSearchComponent, setShowSearchComponent] = useState<boolean>(false);
    const [isTransitioning, setIsTransitioning] = useState<boolean>(true);

    useEffect(() => {
        isTransitioning &&
            window.setTimeout(() => {
                setIsTransitioning(false);
            }, 400);
    }, []);

    const calcTabs = () => {
        if (isOpenTournamentLeaderboard || onlyUsers) {
            return [{ id: TabsType.users, title: translate('Users') }];
        }
        return [
            { id: TabsType.users, title: translate('Users') },
            { id: TabsType.teams, title: translate('Teams') }
        ];
    };

    return isTransitioning ? (
        <FullPageLoader />
    ) : (
        <div className={styles.leaderboard}>
            <div className={styles.wrapper}>
                <div className={showSearchComponent ? styles['search-top'] : styles.top}>
                    {showSearchComponent ? (
                        <Search
                            value={searchString}
                            onChange={(val: string) => setSearchString(val)}
                            onReset={() => {
                                setSearchString('');
                                setShowSearchComponent(false);
                            }}
                            arrowIcon
                            noBackground
                        />
                    ) : (
                        <>
                            <Tabs
                                title={translate('LeaderBoard')}
                                currentTabId={tab}
                                onTabClick={(id: number) => {
                                    setTab(id);
                                    setSearchString('');
                                }}
                                tabs={calcTabs()}
                            />
                            <Icon
                                name="searchIcon"
                                className={styles['search-icon']}
                                onClick={() => setShowSearchComponent(true)}
                            />
                        </>
                    )}
                </div>
                <div className={classnames(styles.content, { [styles['teams-content']]: tab === TabsType.teams })}>
                    {tab === TabsType.users && (
                        <UserLeaderboardContainer
                            tournamentUuid={tournamentUuid}
                            isTournament={Boolean(isOpenTournamentLeaderboard)}
                            searchString={searchString}
                            key={TabsType.users}
                        />
                    )}
                    {tab === TabsType.teams && (
                        <TeamLeaderboardContainer searchString={searchString} key={TabsType.teams} />
                    )}
                </div>
            </div>
            <div className={styles['bottom-section']}>
                <div className={styles['button-wrapper']}>
                    <Button text={translate('close')} type="gradient" onClick={() => onClose()} />
                </div>
            </div>
        </div>
    );
};

enum TabsType {
    users,
    teams
}

interface LeaderboardProps {
    onClose: Function;
    isOpenTournamentLeaderboard?: boolean;
    tournamentUuid?: string;
    onlyUsers?: boolean;
}

export default Leaderboard;
